import {
  get,
  post,
  put,
  patch,
  del,
  createQueryParams,
  getLocalStorageData,
} from "../../axiosComponent";
import { serviceUrls } from "../../constant";

const prepareTransportData = (data = {}) => {
  const profileDetails = getLocalStorageData("profileDetails");
  return {
    ...data,
    siteId: profileDetails["_SITE"],
    regionId: profileDetails["_REGION"],
    organizationId: profileDetails["_ORGANIZATION_"]["_ID"],
  };
};

export const getBookingList = async (data) => {
  return await get({
    url: serviceUrls.TRANSPORT_SERVICE + "/booking/list",
    params: createQueryParams(prepareTransportData(data)),
    includeOrgHeaders: true,
  });
};

export const getBooking = async (entityId) => {
  return await get({
    url: serviceUrls.TRANSPORT_SERVICE + "/booking",
    params: createQueryParams({ entityId }),
    includeOrgHeaders: true,
  });
};

export const addBooking = async (data) => {
  return await post({
    url: serviceUrls.TRANSPORT_SERVICE + "/booking",
    data: prepareTransportData(data),
    includeOrgHeaders: true,
  });
};

export const updateBooking = async (data) => {
  return await put({
    url: serviceUrls.TRANSPORT_SERVICE + "/booking",
    data: prepareTransportData(data),
    includeOrgHeaders: true,
  });
};

export const deleteBooking = async (entityId) => {
  return await del({
    url: serviceUrls.TRANSPORT_SERVICE + "/booking",
    params: createQueryParams({ entityId }),
    includeOrgHeaders: true,
  });
};

export const updateBookingStatus = async (data) => {
  return await patch({
    url: serviceUrls.TRANSPORT_SERVICE + "/booking",
    params: createQueryParams(prepareTransportData(data)),
    includeOrgHeaders: true,
  });
};

export const confirmBooking = async (data) => {
  return await patch({
    url: serviceUrls.TRANSPORT_SERVICE + "/booking/confirm",
    data: prepareTransportData(data),
    includeOrgHeaders: true,
  });
};

export const cancelBooking = async (data) => {
  return await patch({
    url: serviceUrls.TRANSPORT_SERVICE + "/booking/cancel",
    data: prepareTransportData(data),
    includeOrgHeaders: true,
  });
};

export const getBookingHistory = async (data) => {
  return await get({
    url: serviceUrls.TRANSPORT_SERVICE + "/booking/history",
    params: createQueryParams(prepareTransportData(data)),
    includeOrgHeaders: true,
  });
};

export const checkSeatAvailability = async (data) => {
  return await get({
    url: serviceUrls.TRANSPORT_SERVICE + "/booking/availability",
    params: createQueryParams(prepareTransportData(data)),
    includeOrgHeaders: true,
  });
};

export const getBulkBookings = async (data) => {
  return await post({
    url: serviceUrls.TRANSPORT_SERVICE + "/booking/bulk",
    data: prepareTransportData(data),
    includeOrgHeaders: true,
  });
};
